// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Ycsy","notes":"Notes_notes__fCsNy","note":"Notes_note__1J0Re","markdown":"Notes_markdown__iCZsL"};